import React, { useEffect, useState } from "react";
import { adminApi } from "@/api/adminOneClient";

export default function AdminSessions() {
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = async () => { setBusy(true); try { const { data } = await adminApi.sessions(200); setRows(data?.sessions || []); } finally { setBusy(false); } };
  useEffect(()=>{ load(); }, []);
  const toggleArchive = async (s) => {
    try { await adminApi.sessionPatch(s.id, { archived: !s.archived }); await load(); } catch {}
  };
  return (
    <div className="admin-page" data-testid="admin-sessions">
      <div className="admin-page__head">
        <h2 className="admin-page__title">Sessions</h2>
        <button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={load} disabled={busy}>{busy?"…":"↻ Refresh"}</button>
      </div>
      <table className="admin-table">
        <thead><tr><th>Updated</th><th>User</th><th>Active Mode</th><th>Msgs</th><th>Last Query</th><th>Archived</th><th>Actions</th></tr></thead>
        <tbody>
          {rows.map(s=>(
            <tr key={s.id}>
              <td>{s.updated_at && new Date(s.updated_at).toLocaleString()}</td>
              <td><code>{(s.user_id||"").slice(0,10)}…</code></td>
              <td><span className="rc-pill">{(s.active_mode||"").toUpperCase()}</span></td>
              <td>{s.message_count}</td>
              <td className="admin-table__truncate" title={s.last_query}>{s.last_query || "—"}</td>
              <td>{s.archived ? "YES" : "NO"}</td>
              <td><button className="oracle-btn oracle-btn--ghost oracle-btn--sm" onClick={()=>toggleArchive(s)}>{s.archived?"Unarchive":"Archive"}</button></td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={7} className="oracle-empty" style={{padding:14}}>No sessions.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
